import { css } from '@emotion/core'
import { mediumUp } from 'Utils'
import theme from 'Theme'
const {
  colors,
  typography,
  components: { icon }
} = theme

const { mixins, spacing } = theme

export default () => css`
  .applied-filters__title {
    font-weight: normal;
    margin-bottom: ${spacing.base_1}px;
    line-height: 1;
    font-size: ${typography.baseFontSize};
  }

  .applied-filters__links {
    display: flex;
    flex-wrap: wrap;
  }

  .applied-filters__text {
    line-height: 1;
    text-transform: none;
    display: inline-block;
    vertical-align: middle;
    &::first-letter {
      text-transform: uppercase;
    }
  }

  .applied-filters__icon {
    margin-left: 0.5rem;
    width: ${icon.size.small};
    height: ${icon.size.small};
    fill: white;
  }

  .applied-filters__link {
    ${mixins.defaultButton(theme)}
    min-width: auto;
    margin-right: ${spacing.base_1}px;
    margin-bottom: ${spacing.base_1}px;
    position: relative;
    padding: ${spacing.base_1}px;
    background-color: black;
    display: flex;
    align-items: center;
    color: white;

    &:last-of-type {
      margin-right: 0;
    }

    @media ${mediumUp} {
      &:hover {
        background-color: transparent;
        color: ${colors.body};
        .applied-filters__icon {
          fill: ${colors.body};
        }
      }
    }

    &.clear-filters {
      background-color: transparent;
      color: black;

      .applied-filters__icon {
        fill: ${colors.body};
      }
      @media ${mediumUp} {
        &:hover {
          background-color: ${colors.primary};
          color: white;
          .applied-filters__icon {
            fill: white;
          }
        }
      }
    }
  }
`
